<template>
  <div class="mobile-nav-sub" role="none">
    <div class="mobile-nav-sub__inner" role="none">
      <div class="mobile-nav-sub__items container">
        <button class="mobile-nav-sub__back" @click="onBackClick">
          <pt-icon-chevron-right />
          Back
        </button>
        <div v-if="openedNavItem" class="mobile-nav-sub__items-inner">
          <p class="mobile-nav-sub__title">{{ openedNavItem.label }}</p>
          <div v-for="(child, index) in childLinks" :key="`child-item-${index}`" role="none" class="mobile-nav-sub__item">
            <MegaMenuItemLink
              v-if="!child.sub_links || !child.sub_links.length"
              class="mobile-nav__link"
              label-class="mobile-nav__link-label"
              post-icon-class="mobile-nav__link-icon"
              :item="child"
              role="menuitem"
              tabindex="0"
              @link-click="handleLinkClick(child.sub_links && child.sub_links.length, index, $event)"
            />
            <details v-else class="mobile-nav-sub__item-details" name="mobile-nav-sub">
              <summary class="mobile-nav-sub__item-title" @click="handleLinkClick(child.sub_links && child.sub_links.length, index, $event)">
                <MegaMenuItemLink
                  class="mobile-nav__link"
                  label-class="mobile-nav__link-label"
                  post-icon-class="mobile-nav__link-icon"
                  :item="child"
                  :has-drop="child.sub_links && child.sub_links.length > 0"
                  role="menuitem"
                  tabindex="0"
                />
              </summary>
              <div v-if="activeIndex === index">
                <div class="mobile-nav-sub__item-body">
                  <div
                    v-for="(subLink, subIndex) in child.sub_links"
                    :key="`child-sub-item-${subIndex}`"
                    class="mobile-nav-sub__item-link-wrapper"
                    role="none"
                  >
                    <MegaMenuItemLink
                      :item="subLink"
                      class="mobile-nav-sub__item-link link-secondary"
                      role="menuitem"
                      tabindex="0"
                      @link-click="$emit('link-click', $event)"
                    />
                  </div>
                </div>
                <div class="mobile-nav-sub__item-button">
                  <pt-button
                    v-if="child.cta_button && child.cta_button.link"
                    size="extra-small"
                    v-bind="getButtonBindings(child.cta_button)"
                    @click="$emit('link-click', $event)"
                  >
                    {{ child.cta_button.label }}
                  </pt-button>
                </div>
              </div>
            </details>
          </div>
        </div>
      </div>

      <div v-if="secondaryChildLinks && secondaryChildLinks.length" class="mobile-nav-sub__secondary-items">
        <div class="mobile-nav-sub__secondary-items-inner container">
          <p class="mobile-nav-sub__secondary-title">Other</p>
          <div
            v-for="(secondaryChild, index) in secondaryChildLinks"
            :key="`secondary-child-item-${index}`"
            role="none"
            class="mobile-nav-sub__secondary-link-wrapper"
          >
            <MegaMenuItemLink
              :item="secondaryChild"
              class="mobile-nav-sub__secondary-link link-secondary"
              role="menuitem"
              tabindex="0"
              @link-click="$emit('link-click', $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import MegaMenuItemLink from '~/components/ui/layout/mega-menu/MegaMenuItemLink.vue';
import { computed, ref } from 'vue';
import PtIconChevronRight from '~/components/global/icons/PtIconChevronRight.vue';
import { useLayoutNavStore } from '~/stores/layout-nav';
import PtButton from '~/components/global/elements/PtButton.vue';
import { useButtons } from '~/composables/buttons';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  isVisible: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['link-click', 'close']);

const { getButtonBindings } = useButtons();
const layoutNavStore = useLayoutNavStore();
const openedNavItem = computed(() => layoutNavStore.openedNavItem);
const activeIndex = ref<number | null>(null);

const childLinks = computed(() => {
  return Array.isArray(props.item.child_links) ? props.item.child_links : [];
});

const secondaryChildLinks = computed(() => {
  return Array.isArray(props.item.secondary_child_links) ? props.item.secondary_child_links : [];
});

function onBackClick() {
  activeIndex.value = null;
  layoutNavStore.toggleOpenedNavItem(null);
}

function handleLinkClick(hasChild: true, index: number, payload: any) {
  if (hasChild) {
    activeIndex.value = activeIndex.value === index ? null : index;
    return;
  }

  emit('link-click', payload);
}
</script>
